import { SettingsController, TransactionsController, InvoiceController, BusinessController } from '../../controllers';
import { monthName, theYear } from '../../utils/utils';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { useStores } from '../../stores';
import { AppHome } from '../../pages';
import { observer } from 'mobx-react';
import { date, object } from 'yup';

const AppHomeContainer = () => {
	const { userStore, businessStore, transactionStore } = useStores();
	const isActivated = userStore.isActivated;
	const hasPin = userStore.user.hasPin;
	const isOnboarded = userStore.isOnBoardingDone !== 'false';
	const hasWithdrawal = businessStore.business.withdrawalBankAccount;

	let [a, b, c, d] = [0, 0, 0, 0];

	isActivated ? (a = 33) : (a = 0);
	isOnboarded ? (b = 25) : (b = 0);
	hasPin ? (c = 34) : (c = 0);
	hasWithdrawal ? (d = 33) : (d = 0);

	let toDoListTotal = a + c + d;

	const navigate = useNavigate();

	const goToOnboarding = () => {
		!isOnboarded && navigate(constant.Routes.OnboardingStageOne);
	};

	const goToSettings = () => {
		navigate(constant.Routes.Settings);
	};

	useEffect(() => {
		const setTransactions = async () =>
			await Promise.all([
				SettingsController.dashboardData(),
				// InvoiceController.getAnalysis(),
			]);
		setTransactions();
	}, []);

	// const [filterPeriod, setFilterPeriod] = useState(`${monthName} ${theYear}`);
	const [filterPeriod, setFilterPeriod] = useState(`${theYear}`);
	const [loading, setLoading] = useState(false);

	const validationSchema = () => {
		return object({
			startDate: date().required('Start Date is required'),
			endDate: date().required('End Date is required'),
		});
	};

	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}&dateField=createdAt`;
			setFilterPeriod(
				`${payload?.startDate.toDateString()} - ${payload.endDate.toDateString()}`
			);
		}
		setLoading(true);
		await Promise.all([
			TransactionsController.transactionSummary(query),
			TransactionsController.expenseAnalysis(query),
			TransactionsController.transactions(query),
		]);
		setLoading(false);
	};

	const expensePercentage = (value, currencyCode) =>
		(
			(100 * value) /
			transactionStore.expenseAnalysis
			.filter(data => data.currencyCode === currencyCode)[0]
			.value
			.reduce(
				(partialSum, a) => partialSum + a.value,
				0
			)
		).toFixed(2);

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	const resetFilter = async () => {
		await onSubmit();
		setFilterPeriod(`${theYear}`);
	};

	return (
		<div>
			<AppHome
				logout={logout}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				tradingName={
					businessStore.business?.tradingName || userStore.user?.firstname
				}
				expenseAnalysis={transactionStore.expenseAnalysis}
				expensePercentage={expensePercentage}
				transactionsSummary={transactionStore.transactionsSummary}
				loading={loading}
				filterPeriod={filterPeriod}
				resetFilter={resetFilter}
				toDoListTotal={toDoListTotal}
				isActivated={isActivated}
				hasPin={hasPin}
				isOnboarded={isOnboarded}
				hasWithdrawal={hasWithdrawal}
				goToOnboarding={goToOnboarding}
				goToSettings={goToSettings}
			/>
		</div>
	);
};

export default observer(AppHomeContainer);
